import { render, staticRenderFns } from "./IntegrationCard.vue?vue&type=template&id=6aac194a&scoped=true"
import script from "./IntegrationCard.vue?vue&type=script&lang=js"
export * from "./IntegrationCard.vue?vue&type=script&lang=js"
import style0 from "./IntegrationCard.vue?vue&type=style&index=0&id=6aac194a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aac194a",
  null
  
)

export default component.exports